<div class="dialog-viewer">
    <h2 mat-dialog-title>Edit Registration</h2>
    <mat-dialog-content>
        <mat-form-field>
            <input matInput placeholder="Name" [(ngModel)]="detail.name" />
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="Description" [(ngModel)]="detail.description" />
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="Cost" [(ngModel)]="detail.cost" type="number" />
            <mat-icon matPrefix style="vertical-align: middle;">attach_money</mat-icon>
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="Notes" [(ngModel)]="detail.notes" />
        </mat-form-field>
        <mat-progress-bar mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="text-center">
            <button mat-raised-button (click)="submit()" [disabled]="isSaving">{{submitText}}</button>
            <button mat-raised-button (click)="cancel()" color="warn" [disabled]="isSaving">Cancel</button>
        </div>
    </mat-dialog-actions>
</div>